import React, { useState } from 'react';
import useUpgradeDialog from '../../../hooks/useUpgradeDialog';
import {
  PageContainer,
  Logo,
  LogoIcon,
  LogoImage,
  LogoText,
  ContentContainer,
  Heading,
  CouponContainer,
  CouponCode as CouponCodeStyled,
  CopyButton,
  CopyIcon,
  InstructionText,
  UpgradeButton,
  ConeLeft,
  ConeRight,
  CloseIcon
} from './style';
import jeddleLogo from '../../../static/icons/jeddle_icon.png';
import conicalGif from '../../../static/gif/conical-gif.gif';
import CopyIconImage from '../../../static/icons/copy-white-icon.svg';
import closeIconImage from '../../../static/img/white-cross12.svg';

const CouponCode = ({ 
  onCopy,
  onUpgrade,
  couponCode = 'REF7411',
  onClose,
}) => {
  const [copied, setCopied] = useState(false);
  const [requestError, setRequestError] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const close = onClose ? () => { if (!isRedirecting) onClose(); } : undefined;
  const dialogRef = useUpgradeDialog(true, close);

  const handleCopy = async () => {
    setRequestError(null);
    try {
      await navigator.clipboard.writeText(couponCode);
      setCopied(true);
      if (onCopy) {
        onCopy(couponCode);
      }
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      setRequestError('Could not copy automatically. Select the code above to copy it.');
    }
  };

  const handleUpgrade = async () => {
    setIsRedirecting(true);
    setRequestError(null);
    try {
      if (onUpgrade) await onUpgrade();
    } catch (error) {
      setRequestError('We could not open checkout. Please try again.');
      setIsRedirecting(false);
    }
  };

  return (
    <PageContainer ref={dialogRef} role="dialog" aria-modal="true" aria-label="Referral coupon" tabIndex={-1}>
      {close && <CloseIcon aria-label="Close" onClick={close} disabled={isRedirecting}><img src={closeIconImage} alt="" /></CloseIcon>}
      <ConeLeft src={conicalGif} alt="Decoration" />
      <ConeRight src={conicalGif} alt="Decoration" />
      
      <Logo>
        <LogoIcon><LogoImage src={jeddleLogo} alt="Jeddle Logo" /></LogoIcon>
        <LogoText>jeddle</LogoText>
      </Logo>
      
      <ContentContainer>
        <Heading>
          Here's your exclusive<br />
          coupon code 🎉
        </Heading>
        
        <CouponContainer>
          <CouponCodeStyled>{couponCode}</CouponCodeStyled>
          <CopyButton onClick={handleCopy}>
            <CopyIcon><img src={CopyIconImage} alt="" /></CopyIcon>
            {copied ? 'Copied!' : 'Copy'}
          </CopyButton>
        </CouponContainer>
        
        <InstructionText>
          Use this code at checkout for 50% off your first Pro payment. Renewals are at the standard price.
        </InstructionText>
        
        {requestError && <InstructionText role="alert">{requestError}</InstructionText>}
        <UpgradeButton onClick={handleUpgrade} disabled={isRedirecting}>
          Upgrade Now
        </UpgradeButton>
      </ContentContainer>
    </PageContainer>
  );
};

export default CouponCode;
